import { render } from "./ModalEditarParametros.vue?vue&type=template&id=a19946a2&scoped=true"
import script from "./ModalEditarParametros.vue?vue&type=script&lang=js"
export * from "./ModalEditarParametros.vue?vue&type=script&lang=js"

import "./ModalEditarParametros.vue?vue&type=style&index=0&id=a19946a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19946a2"]])

export default __exports__